import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { useMeApi } from '~/lib/api/me/use-me-api';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

export interface IApiResponse<T> {
  success: boolean;
  result: T | null;
}

export function useAchievements() {
  const { addAchievements: meAdd, getAchievements } = useMeApi();
  const { track } = useAnalytics();

  const addAchievements = useCallback(
    (sections: string[], achievements: string[]) => {
      try {
        for (const achievement of achievements) {
          track({
            type: 'add_achievement',
            payload: {
              ...GenerateBaseAnalyticsPayload(sections),
              achievement: achievement,
              achievements: achievements
            }
          });
        }
      } catch (e) {
        console.error('Error tracking achievements', e);
      }

      return meAdd(achievements);
    },
    [meAdd, track]
  );

  return {
    addAchievements,
    getAchievements
  } as const;
}
